var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-live":"polite"}},[_c('v-expand-transition',[(_vm.isFormError)?_c('h-error-box',_vm._b({attrs:{"text":_vm.errorTranslation()}},'h-error-box',_vm.$attrs,false)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }